import { Controller } from "@hotwired/stimulus"

// ハンバーガーメニューコントローラー
export default class extends Controller {
  static targets = ["button"]
  
  connect() {
    console.log("[Stimulus] Hamburger controller connected")
  }
  
  // ハンバーガーメニューボタンがクリックされたときの処理
  toggle(event) {
    if (event) event.preventDefault()
    
    // slideoverコントローラーを取得
    const slideoverElement = document.querySelector('[data-controller="slideover"]')
    if (slideoverElement) {
      // slideoverコントローラーのインスタンスを取得
      const application = this.application
      const slideoverController = application.getControllerForElementAndIdentifier(
        slideoverElement,
        'slideover'
      )
      
      // openメソッドを呼び出す
      if (slideoverController && typeof slideoverController.open === 'function') {
        slideoverController.open()
        console.log('[Hamburger] Menu opened via Stimulus controller')
      } else {
        console.error('[Hamburger] Could not find slideover controller or open method')
      }
    } else {
      console.error('[Hamburger] Could not find slideover element')
    }
  }
}
